import type { CoachSuggestionComponent } from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestion';
import { ResolutionStatus } from 'bundles/ai-coach-platform/components/patterns/suggestions/types';

export const getResolvedSuggestions = (suggestions: CoachSuggestionComponent[]) => {
  return suggestions.filter(({ props: { status } }) => status !== ResolutionStatus.UNRESOLVED);
};

export const getUnresolvedSuggestions = (suggestions: CoachSuggestionComponent[]) => {
  return suggestions.filter(
    ({ props: { disabled, status } }) =>
      !disabled && (status === ResolutionStatus.UNRESOLVED || status === ResolutionStatus.AUTO_APPLIED)
  );
};

export const getFirstUnresolvedSuggestionId = (suggestions: CoachSuggestionComponent[]) => {
  const suggestion = getUnresolvedSuggestions(suggestions)[0];
  return suggestion?.props.id;
};
